import { render, staticRenderFns } from "./accessdenied.vue?vue&type=template&id=16f3e4d1&scoped=true"
import script from "./accessdenied.vue?vue&type=script&lang=js"
export * from "./accessdenied.vue?vue&type=script&lang=js"
import style0 from "./accessdenied.vue?vue&type=style&index=0&id=16f3e4d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3e4d1",
  null
  
)

export default component.exports